import { render, staticRenderFns } from "./FragmentBoxList.vue?vue&type=template&id=749d3b26&"
import script from "./FragmentBoxList.vue?vue&type=script&lang=ts&"
export * from "./FragmentBoxList.vue?vue&type=script&lang=ts&"
import style0 from "./FragmentBoxList.vue?vue&type=style&index=0&id=749d3b26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports